import React, { FC } from 'react';

type PropsType = {
  index: number;
  avatarSelected: number;
  children?: never;
  active: boolean;
  onClick: () => void;
  img: any;
};

export const AvatarCard: FC<PropsType> = ({ onClick, index, active, img, avatarSelected }: PropsType) => {
  if (index === 0) {
    return (
      <div
        className={`avatar-wrap avatar-wrap--none ${
          avatarSelected === 0 || avatarSelected === -1 ? 'avatar-wrap--selected' : ''
        } avatar-overlay`}
        onClick={onClick}
      >
        NONE
      </div>
    );
  } else {
    return (
      <div className={`avatar-wrap ${active ? 'avatar-wrap--selected' : ''} avatar-overlay`} onClick={onClick}>
        <img className="avatar-img" src={img} alt="avatar" />
      </div>
    );
  }
};
